import { createFileRoute, Navigate } from '@tanstack/react-router'

import { useAuth } from '@/features/auth/use-auth.ts'
import { LoadingSpinner } from '@/components/spinner/loading-spinner.tsx'

export const Route = createFileRoute('/')({
  component: Home,
})

function Home() {
  const auth = useAuth()
  if (auth.loading) {
    return (
      <LoadingSpinner
        wrapperClassName="min-h-svh flex items-center justify-center"
        className="size-12"
      />
    )
  }

  return <Navigate to="/documents/browse" />
}
